import {
  WORKER_CONFIG_LOGOUT_BEGIN,
  WORKER_CONFIG_LOGOUT_SUCCESS,
  WORKER_CONFIG_LOGOUT_FAILURE,
  WORKER_CONFIG_LOGOUT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import moment from 'moment';
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function logout(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: WORKER_CONFIG_LOGOUT_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      axios.get("/api/session/logout")
      .then(
        (res) => {
          dispatch({
            type: WORKER_CONFIG_LOGOUT_SUCCESS,
            data: {res}
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: WORKER_CONFIG_LOGOUT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissLogoutError() {
  return {
    type: WORKER_CONFIG_LOGOUT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case WORKER_CONFIG_LOGOUT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        logoutPending: true,
        logoutError: null,
      };

    case WORKER_CONFIG_LOGOUT_SUCCESS:
      // The request is success
      return {
        ...state,
        loggedInUser: undefined,
        displayedUser: undefined,
        logoutPending: false,
        logoutError: null,
      };

    case WORKER_CONFIG_LOGOUT_FAILURE:
      // The request is failed
      return {
        ...state,
        logoutPending: false,
        logoutError: action.data.error,
      };

    case WORKER_CONFIG_LOGOUT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        logoutError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/worker-config/redux/logout.js